import type { CustomerConfig } from "../../types";

export const automotiveVenturesConfig: CustomerConfig = {
	id: "automotive-ventures",
	name: "Automotive Ventures",
	shortName: "Automotive Ventures",
	accessTokens: ["8ce818497458e85b6bff071ed59e5e78"],
	accessExpiry: new Date("2026-05-17T23:59:59Z"),
	onsiteDates: "May 15, 2026",
	theme: {
		accentColor: "#ef4444",
		accentColorLight: "#f87171",
		secondaryAccent: "#fb923c",
		pathColorFrom: "#ef4444",
		pathColorTo: "#f43f5e",
		slideAccentBar: "#ef4444",
	},
	logos: {
		customer: "/assets/logos/automotive-ventures.png",
		null: "/null/logo.white.svg",
	},
	demoUrl: "https://app.dev.null.autos",
	demoLabel: "Launch Null Autos Platform",
	confidentialityNotice:
    "CONFIDENTIAL — Any disclosure, use, reproduction, or distribution of this information without the express written consent of Null Autos is strictly prohibited.",
};
